import { Box, Button, Paper, Typography } from '@mui/material'
import svg from 'assets/svg/404_Error.svg'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

const NotFoundPage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const goBack = () => navigate(-1)

  return (
    <Paper
      sx={{
        padding: '2rem 5rem',
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '50rem',
        width: '100%',
        margin: '2rem auto',
      }}
    >
      <Typography
        variant='h5'
        align='center'
        sx={{ textTransform: '', color: '#000'}}
      >{`${t('errors.not-found')}`}</Typography>
      <Box
        component='img'
        sx={{
          height: 'auto',
          width: '75%',
          margin: '0 auto',
        }}
        alt='not found'
        src={svg}
      />
      <Button variant='contained' onClick={goBack} sx={{ width: '65%', margin: '0 auto', color: '#000' }}>
        {`${t('common.back')}`}
      </Button>
    </Paper>
  )
}
export default NotFoundPage
